import { render, staticRenderFns } from "./AddOpeningBalance.vue?vue&type=template&id=42ba30d0&"
import script from "./AddOpeningBalance.vue?vue&type=script&lang=js&"
export * from "./AddOpeningBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports